import type { EnMessages } from './en.js';

export const ru: EnMessages = {
  common: {
    'appName': 'Appwin',
    'retry': 'Повторить',
    'cancel': 'Отмена',
    'close': 'Закрыть',
    'save': 'Сохранить',
    'delete': 'Удалить',
    'confirm': 'Подтвердить',
    'back': 'Назад',
    'next': 'Далее',
    'search': 'Поиск',
    'loading': 'Загрузка…',
    'noData': 'Нет данных',
    'enabled': 'Включено',
    'disabled': 'Отключено',
    'yes': 'Да',
    'no': 'Нет',
    'copy': 'Копировать',
    'copied': 'Скопировано',
    'learnMore': 'Подробнее',
    'seeAll': 'Смотреть все',
    'optional': 'необязательно',
    'required': 'обязательно',
    'settings': 'Настройки',
    'signIn': 'Войти',
    'signOut': 'Выйти',
    'language': 'Язык',
    'version': 'Версия',
    'size': 'Размер',
    'updated': 'Обновлено',
    'actions': 'Действия',
    'status': 'Статус',
    'reason': 'Причина',
    'date': 'Дата',
    'unknown': 'Неизвестно',
    'none': 'Нет',
  },
  nav: {
    'catalog': 'Каталог',
    'updates': 'Обновления',
    'installed': 'Установленные',
    'settings': 'Настройки',
    'open': 'Открыть Appwin',
    'checkUpdates': 'Проверить обновления',
    'quit': 'Выход',
  },
  catalog: {
    'title': 'Каталог приложений',
    'subtitle': 'Находите, устанавливайте и обновляйте приложения для Windows.',
    'searchPlaceholder': 'Поиск приложений',
    'categories': 'Категории',
    'allCategories': 'Все категории',
    'empty': 'Ничего не найдено',
    'emptyHint': 'Попробуйте другой запрос или категорию.',
    'resultsCount': 'Приложений: {count}',
    'loadMore': 'Показать ещё',
    'externalSource': 'Внешний источник',
    'externalSourceHint':
      'Приложение импортировано из winget. Файлы скачиваются с сайта разработчика.',
    'updatedRecently': 'Недавно обновлены',
    'popular': 'Популярные',
    'new': 'Новые',
    'unverified': 'Издатель не подтверждён',
  },
  app: {
    'install': 'Установить',
    'installed': 'Установлено',
    'update': 'Обновить',
    'reinstall': 'Переустановить',
    'open': 'Открыть',
    'details': 'Описание',
    'screenshots': 'Скриншоты',
    'changelog': 'Что нового',
    'versions': 'Версии',
    'releaseNotes': 'История версий',
    'homepage': 'Сайт',
    'license': 'Лицензия',
    'developer': 'Разработчик',
    'category': 'Категория',
    'requirements': 'Требования',
    'arch': 'Архитектура',
    'scope_per_user': 'Для текущего пользователя',
    'scope_machine': 'Для всех пользователей',
    'scope_portable': 'Портативная',
    'signature_valid': 'Подписано цифровой подписью',
    'signature_none': 'Без подписи',
    'signature_invalid': 'Неверная подпись',
    'signature_unverified': 'Подпись не проверена',
    'autoUpdate': 'Автоматические обновления',
    'manualUpdateOnly': 'Только ручные обновления',
    'notFound': 'Приложение не найдено',
  },
  install: {
    'planTitle': 'Установка {name} {version}',
    'planSource': 'Источник',
    'planSize': 'Размер загрузки',
    'planRights': 'Права',
    'planRights_per_user': 'Устанавливается только для текущего пользователя.',
    'planRights_machine': 'Потребуется подтверждение администратора (UAC).',
    'planRights_portable': 'Распакуется в портативную папку, система не изменяется.',
    'planSignature': 'Подпись издателя',
    'planContinue': 'Продолжить',
    'downloading': 'Скачивание…',
    'verifying': 'Проверка целостности файла…',
    'verifyingSignature': 'Проверка подписи…',
    'installing': 'Установка…',
    'verifyingInstall': 'Проверка установки…',
    'rebootRequired': 'Для завершения нужна перезагрузка.',
    'restartLater': 'Позже',
    'restartNow': 'Перезагрузить',
    'success': 'Установлено',
    'launch': 'Запустить',
    'whyFailed': 'Почему не получилось?',
    'errorHash': 'Скачанный файл не совпадает с опубликованным SHA-256. Установка остановлена.',
    'errorSignature': 'Подпись фида недействительна. Установка остановлена.',
    'errorNetwork': 'Ошибка сети при скачивании. Проверьте подключение и повторите.',
    'errorElevation': 'Подтверждение администратора отклонено.',
    'errorTimeout': 'Установщик не завершился за отведённое время.',
    'errorGeneric': 'Установка не удалась (код {code}).',
    'manualInstallRequired': 'Это приложение можно установить только вручную.',
    'manualInstallHint': 'Откройте страницу загрузки и запустите установщик самостоятельно.',
    'openDownloadPage': 'Открыть страницу загрузки',
    'cancelled': 'Установка отменена',
  },
  updates: {
    'title': 'Обновления',
    'allUpToDate': 'Всё обновлено',
    'allUpToDateHint': 'Appwin проверяет обновления каждые четыре часа.',
    'updateAll': 'Обновить все ({count})',
    'available': 'Доступно обновлений: {count}',
    'skipVersion': 'Пропустить эту версию',
    'pinVersion': 'Оставить текущую версию',
    'unpin': 'Снова разрешить обновления',
    'whyNotUpdated': 'Почему не обновляется автоматически?',
    'reasonNoSilent': 'Издатель не указал параметры тихой установки.',
    'reasonIneligible': 'Этот релиз исключён из автоматических обновлений.',
    'reasonUnknownMatch': 'Appwin не уверен, что установленное приложение — то же самое.',
    'reasonPinned': 'Вы решили оставить текущую версию.',
    'reasonSkipped': 'Вы пропустили эту версию.',
    'rollback': 'Вернуть версию {version}',
    'rollbackUnavailable': 'Предыдущей версии больше нет в кэше.',
    'checking': 'Проверка обновлений…',
    'lastChecked': 'Последняя проверка: {time}',
    'neverChecked': 'Ещё не проверялось',
  },
  installed: {
    'title': 'Установленные приложения',
    'subtitle': 'Приложения, найденные на этом компьютере.',
    'scanning': 'Сканирование установленных приложений…',
    'source_catalog': 'Из Appwin',
    'source_registry': 'Реестр системы',
    'source_msix': 'Пакет Microsoft Store',
    'confidence_exact': 'Точное совпадение',
    'confidence_probable': 'Вероятное совпадение',
    'confidence_unknown': 'Совпадение не определено',
    'notThisApp': 'Это другое приложение',
    'notThisAppSent': 'Спасибо, мы проверим это сопоставление.',
    'empty': 'Установленные приложения не найдены',
    'filterPlaceholder': 'Фильтр установленных приложений',
  },
  settings: {
    'title': 'Настройки',
    'autoUpdate': 'Автоматически обновлять приложения',
    'autoUpdateHint': 'Проверка каждые четыре часа, пока Appwin запущен.',
    'startWithWindows': 'Запускать Appwin при входе',
    'startWithWindowsHint': 'Работает в фоне в системном трее.',
    'keepInTray': 'Оставаться в трее после закрытия окна',
    'language': 'Язык интерфейса',
    'telemetry': 'Отправлять анонимные отчёты об установке',
    'telemetryHint':
      'Помогает находить сломанные установщики. Передаются только id приложения, результат и код ошибки — не содержимое файлов, не имена файлов и не ваши данные.',
    'proxy': 'Прокси',
    'proxyHint': 'Необязательно. Формат: http://host:port или socks5://host:port',
    'cacheLimit': 'Лимит кэша загрузок',
    'clearCache': 'Очистить кэш',
    'cacheCleared': 'Кэш очищен',
    'about': 'Об Appwin',
    'clientVersion': 'Версия клиента',
    'apiVersion': 'Версия API',
    'diagnostics': 'Открыть папку логов',
    'resetClientId': 'Сбросить анонимный id клиента',
  },
  errors: {
    'generic': 'Что-то пошло не так. Попробуйте ещё раз.',
    'network': 'Сервис Appwin недоступен.',
    'offline': 'Нет подключения. Часть функций недоступна.',
    'rateLimited': 'Слишком много запросов. Подождите немного.',
    'apiOutdated': 'Обновите Appwin, чтобы продолжить.',
    'apiOutdatedHint': 'Эта версия приложения слишком стара для текущего сервиса.',
    'updateAppwin': 'Обновить Appwin',
    'invalidDeepLink': 'Ссылка не открыта: это не корректная ссылка Appwin.',
    'appYanked': 'Эта версия отозвана издателем или модератором.',
    'appDelisted': 'Это приложение больше недоступно.',
  },
  web: {
    'downloadClient': 'Скачать Appwin для Windows',
    'downloadClientHint': 'Бесплатно. Windows 10 и 11, x64 и ARM64.',
    'openInAppwin': 'Открыть в Appwin',
    'openInAppwinHint': 'Если Appwin установлен, приложение откроется сразу.',
    'getAppwinFirst': 'Appwin ещё не установлен',
    'getAppwinFirstHint': 'Скачайте Appwin, чтобы устанавливать приложения в один клик.',
    'installTitle': 'Установка {name}',
    'notFoundTitle': 'Страница не найдена',
    'notFoundHint': 'Возможно, приложение было удалено из каталога.',
    'description': 'Каталог приложений для Windows с проверенными установщиками и автообновлением.',
    'skipToContent': 'Перейти к содержимому',
    'searchCatalog': 'Поиск по каталогу',
    'directDownload': 'Скачать установщик',
    'directDownloadHint': 'Откроется файл на сайте издателя. Appwin не хранит его у себя.',
    'versionsAvailable': 'Доступных версий: {count}',
  },
  developer: {
    'title': 'Кабинет разработчика',
    'signInGithub': 'Продолжить с GitHub',
    'signInEmail': 'Продолжить по email',
    'emailLabel': 'Email',
    'sendCode': 'Отправить код',
    'codeLabel': 'Код из шести цифр',
    'codeSent': 'Мы отправили код на {email}.',
    'verify': 'Подтвердить',
    'myApps': 'Мои приложения',
    'newApp': 'Новое приложение',
    'appIdLabel': 'Идентификатор приложения',
    'appIdHint': 'Постоянный. Формат: ваш-ник/имя-приложения. Изменить потом нельзя.',
    'nameLabel': 'Название',
    'categoryLabel': 'Категория',
    'summaryLabel': 'Краткое описание',
    'descriptionLabel': 'Полное описание',
    'homepageLabel': 'Сайт',
    'licenseLabel': 'Лицензия (SPDX)',
    'uploadRelease': 'Загрузить релиз',
    'uploadVersion': 'Версия',
    'uploadFile': 'Файл установщика',
    'uploadKind': 'Тип пакета',
    'uploadScope': 'Область установки',
    'silentArgs': 'Параметры тихой установки',
    'silentArgsHint': 'Обязательны для EXE и MSI, иначе автообновление недоступно.',
    'upgradeArgs': 'Параметры обновления',
    'submitForReview': 'Отправить на проверку',
    'submitted': 'Отправлено. Проверка обычно занимает до двух рабочих дней.',
    'apiKeys': 'API-ключи',
    'newApiKey': 'Новый API-ключ',
    'apiKeyOnce': 'Скопируйте ключ сейчас: больше он не будет показан.',
    'revoke': 'Отозвать',
    'stats': 'Статистика',
    'claimWinget': 'Заявить права на пакет winget',
    'claimHint': 'Импортировать запись winget и управлять ею как своим приложением.',
    'releaseInReview': 'На проверке',
    'releasePublished': 'Опубликован',
    'releaseRejected': 'Отклонён',
    'releaseYanked': 'Отозван',
  },
  admin: {
    'title': 'Админка Appwin',
    'moderation': 'Очередь модерации',
    'approve': 'Одобрить',
    'reject': 'Отклонить',
    'yank': 'Отозвать',
    'checks': 'Автоматические проверки',
    'sha256': 'SHA-256',
    'av': 'Антивирус',
    'authenticode': 'Подпись кода',
    'imports': 'Импорт winget',
    'runImport': 'Запустить импорт',
    'stats': 'Дашборд',
    'audit': 'Журнал аудита',
    'installs': 'Установки',
    'updates': 'Обновления',
    'successRate': 'Доля успешных',
    'noTelemetry': 'Нет данных — отчёты отключены или не поступали.',
    'topApps': 'Самые устанавливаемые приложения',
    'topErrors': 'Самые частые ошибки',
    'pending': 'Ждут проверки',
    'delist': 'Снять с публикации',
    'relist': 'Вернуть в каталог',
    'hashMismatches': 'Расхождения хэшей',
    'lastRun': 'Последний импорт',
  },
};
